import { getReturnProtectionLineItem } from '../helpers'
import { sampleCartProducts } from './constants'

export const getOrderSummaryLines = ({ title, image }) => [
  getReturnProtectionLineItem({ title, image }),
  ...sampleCartProducts,
]

export const getOrderSummaryTotals = lines => {
  return lines.reduce(
    (totals, line) => {
      return {
        itemsCount: totals.itemsCount + line.quantity,
        subtotal: totals.subtotal + line.price * line.quantity,
      }
    },
    { itemsCount: 0, subtotal: 0 }
  )
}
